import { render, staticRenderFns } from "./totalSumChart.vue?vue&type=template&id=bd54f6be&scoped=true&"
import script from "./totalSumChart.vue?vue&type=script&lang=js&"
export * from "./totalSumChart.vue?vue&type=script&lang=js&"
import style0 from "./totalSumChart.vue?vue&type=style&index=0&id=bd54f6be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd54f6be",
  null
  
)

export default component.exports